import type * as React from 'react';
import Colors from './Colors';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';

export interface ThemeProviderProps {
  /** Children to render */
  children?: React.ReactNode;
}

// Create a default theme that matches the app's styling
const defaultTheme = createTheme({
  palette: {
    primary: {
      main: Colors.blue,
    },
    secondary: {
      main: Colors.brandCyan,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'uppercase',
        },
      },
    },
  },
});

/**
 * ThemeProvider wrapper - wraps MUI ThemeProvider
 * - The react-toolbox theme prop (CSS class mappings) is ignored
 * - Uses MUI's default theme structure instead
 */
const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  // The react-toolbox theme is CSS class mappings, not MUI theme config
  // We use our own default MUI theme instead
  return <MuiThemeProvider theme={defaultTheme}>{children}</MuiThemeProvider>;
};

ThemeProvider.displayName = 'ThemeProvider';

export default ThemeProvider;
